<script>
import HorizontalScrollList from '@components/HorizontalScrollList'
import ImageLoader from '@components/ImageLoader'
import Button from '@components/Button'
import Accordion from '@components/Accordion'
import VideoPlayer from '@components/VideoPlayer'
import Price from '@components/Price'
import Dialog from '@components/Dialog'
import AreaCursosDemo from '@components/AreaCursosDemo'
import CardCadastro from '@components/CardCadastro'
import ImageBroken from '@/assets/image-broken.svg'
import chroma from 'chroma-js'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'App',
  components: {
    ImageBroken,
    HorizontalScrollList,
    ImageLoader,
    Accordion,
    Button,
    VideoPlayer,
    Price,
    Dialog,
    AreaCursosDemo,
    CardCadastro
  },
  data: () => ({
    dialogVideoTitle: '',
    temVideo: false
  }),
  computed: {
    ...mapState(['cursos']),
    price () {
      try {
        const { moeda, valor, intervalo } = (this.wl.strings.mensalidade.match(/(?<moeda>.*)\s(?<valor>\d+,\d+)\s?(?<intervalo>.*)/)).groups
        return {
          moeda,
          valor,
          intervalo
        }
      } catch {
        return null
      }
    },
    motivos () {
      return Object.keys(this.wl.images).filter(key => /MOTIVO_\d+_ICON/.test(key)).map(iconKey => {
        const index = Number(iconKey.replace(/\D+/g, ''))
        const descReg = new RegExp(`^motivo-0+?${index}$`)
        const descKey = Object.keys(this.wl.strings).find(key => descReg.test(key))
        return {
          icon: this.wl.images[iconKey],
          description: this.wl.strings[descKey]
        }
      })
    },
    faq () {
      const questions = {}
      const answers = {}
      Object.keys(this.wl.strings).forEach(key => {
        if (/^faq-question-\d+$/.test(key)) {
          const index = Number(key.replace(/^faq-question-/, ''))
          questions[index] = this.wl.strings[key]
        }
        if (/^faq-answer-\d+$/.test(key)) {
          const index = Number(key.replace(/^faq-answer-/, ''))
          answers[index] = this.wl.strings[key]
        }
      })
      const items = Object.keys(questions).map(index => {
        return {
          title: questions[index],
          content: answers[index]
        }
      })
      return items
    },
    styles () {
      return {
        home: {
          '--scale': this.scale,
          '--margin': this.rl.margin
        },
        header: {
          '--text-align': this.rl.mdAndUp ? 'left' : 'center',
          '--btn-margin-horizontal': this.rl.mdAndUp ? '0px' : 'auto'
        },
        price: {
          '--box-shadow-color': chroma(this.wl.colors.secondary).alpha(0.3)
        }
      }
    },
    scale () {
      return {
        xs: 0.5,
        sm: 0.6,
        md: 0.8,
        lg: 1,
        xl: 1
      }[this.rl.breakpoint]
    }
  },
  created () {
    this.getCursos({ regPag: 8 })
    this.getCursosDemo()
  },
  methods: {
    ...mapActions(['getCursos', 'getCursosDemo']),
    abrirDialogVideo (curso) {
      this.dialogVideoTitle = curso.nome
      this.$refs.dialogDetalheCurso.open()
      this.temVideo = !!curso.video
      this.$nextTick(() => {
        if (this.$refs['iframe-video']) this.$refs['iframe-video'].src = curso.video
      })
    },
    assinar () {
      if (typeof dataLayer !== 'undefined') dataLayer.push({ event: 'btn_quero_assinar' })
      this.$refs.dialogAssinatura.open()
    }
  }
}
</script>

<template>
  <div
    id="home"
    :style="styles.home"
  >
    <section
      id="header"
      :style="styles.header"
    >
      <VideoPlayer
        :width="rl.mdAndUp ? `calc(50vw - ${rl.margin})` : `calc(100vw - 2 * ${rl.margin})`"
        class="video-player"
      />
      <div class="right-container">
        <h1
          class="view-home-header-title"
          v-html="wl.strings['view-home-header-title']"
        />
        <p
          class="view-home-header-content"
          v-html="wl.strings['view-home-header-content']"
        />
        <div
          class="price-container"
          :style="styles.price"
        >
          <div class="price-shadow">
            <p
              class="mensalidade-antiga"
              v-html="wl.strings['mensalidade-antiga']"
            />
            <Price
              v-if="price"
              class="price"
              :scale="scale"
              :moeda="price.moeda"
              :valor="price.valor"
              :intervalo="price.intervalo"
            />
            <Button
              :size="rl.mdAndUp ? 'lg' : 'md'"
              class="btn-assine-agora"
              :color="wl.colors.secondary"
              :text-color="wl.colors.on.secondary"
              :text="wl.strings['btn-assine-agora']"
              :scale="scale"
              @click="() => { assinar() }"
            />
          </div>
          <p class="mensalidade-observacao">
            {{ wl.strings['mensalidade-observacao'] }}
          </p>
        </div>
      </div>
    </section>
    <section id="porque-assinar-woliflix">
      <div class="left-container">
        <h1
          class="view-home-title-porque-assinar-woliflix"
          v-html="wl.strings['view-home-title-porque-assinar-woliflix']"
        />
        <div class="motivos">
          <div
            v-for="motivo in motivos"
            :key="motivo.description"
            class="motivo"
          >
            <ImageLoader
              :url="motivo.icon"
              class="icon"
            />
            <p
              class="description"
              v-html="motivo.description"
            />
          </div>
        </div>
      </div>
      <div
        class="right-container"
        :style="rl.width < 467 && {
          borderTop: '1px solid var(--on-primary)',
          marginTop: 'calc(30px * var(--scale))'
        }"
      >
        <CardCadastro :scale="scale" />
      </div>
    </section>
    <AreaCursosDemo
      :scale="scale"
      @click="(curso) => abrirDialogVideo(curso)"
    />
    <section id="cursos">
      <h1
        class="view-home-title-conteudo"
        v-html="wl.strings['view-home-title-conteudo']"
      />

      <HorizontalScrollList
        v-if="cursos.length === 0"
        key="placeholder"
        :columns="{xs: 2, sm: 4, md: 4, lg: 4, xl: 8}[rl.breakpoint]"
        :show-arrows="rl.mdAndUp"
        :margin="rl.margin"
        :gutter="rl.gutter"
        :aspect-ratio="2.44048"
      >
        <ImageLoader url="" />
        <ImageLoader url="" />
      </HorizontalScrollList>
      <HorizontalScrollList
        v-else
        :columns="{xs: 2, sm: 4, md: 4, lg: 4, xl: 8}[rl.breakpoint]"
        :show-arrows="rl.mdAndUp"
        :margin="rl.margin"
        :gutter="rl.gutter"
        :aspect-ratio="2.44048"
      >
        <ImageLoader
          v-for="curso in cursos"
          :key="curso.id"
          :url="curso.imagemVertical"
          @click="() => abrirDialogVideo(curso)"
        />
      </HorizontalScrollList>
      <Button
        :size="rl.mdAndUp ? 'lg' : 'md'"
        class="btn-todos-cursos"
        :color="wl.colors.secondary"
        :text-color="wl.colors.on.secondary"
        :text="wl.strings['btn-todos-cursos']"
        outlined
        :scale="scale"
        @click="$router.push({name: 'Cursos'})"
      />
    </section>
    <section
      id="faq"
      :style="styles.faq"
    >
      <h1
        class="faq-title"
        v-html="wl.strings['faq-title']"
      />
      <Accordion
        :scale="scale"
        :items="faq"
        :title-color="wl.colors.on.background"
        :content-color="wl.colors.on.background"
      />
      <Button
        :size="rl.mdAndUp ? 'lg' : 'md'"
        class="btn-assine-agora"
        :color="wl.colors.secondary"
        :text-color="wl.colors.on.secondary"
        :text="wl.strings['btn-assine-agora']"
        :scale="scale"
        @click="() => { assinar() }"
      />
    </section>
    <Dialog
      id="dialog-detalhe-curso"
      ref="dialogDetalheCurso"
      :fullscreen="rl.smAndDown"
      @close="() => { if($refs['iframe-video']) $refs['iframe-video'].src = '' }"
    >
      <template v-slot:title>
        {{ dialogVideoTitle }}
      </template>
      <template v-slot:text>
        <iframe
          v-if="temVideo"
          ref="iframe-video"
          frameborder="0"
          allow="autoplay; fullscreen"
          allowfullscreen=""
          width="100%"
          height="254px"
          :title="dialogVideoTitle"
        />
        <div
          v-else
          class="video-indisponivel"
        >
          <ImageBroken />
          <p v-html="wl.strings['video-indisponivel']" />
        </div>
        <div
          class="gostou-do-conteudo"
          style="font-weight: 600"
          v-html="wl.strings['gostou-do-conteudo']"
        />
        <Button
          :size="'md'"
          class="btn-assine-agora"
          :color="wl.colors.primary"
          :text-color="wl.colors.on.primary"
          :text="wl.strings['btn-assine-agora']"
          style="margin: 30px auto 15px"
          :scale="scale"
          @click="() => { assinar() }"
        />
      </template>
    </Dialog>
    <Dialog
      id="dialog-assinatura"
      ref="dialogAssinatura"
      fullscreen
      dense
    >
      <template v-slot:text>
        <iframe
          width="100%"
          height="100%"
          :src="wl.urls.assinatura"
          style="border:none; height: calc(100vh - 55px);"
        />
      </template>
    </Dialog>
  </div>
</template>

<style lang="scss" scoped>
#home {
  #header {
    margin: 0 var(--margin);
    display: flex;
    flex-wrap: wrap;
    .right-container {
      text-align: var(--text-align);
      flex: 1;
      padding-left: calc(25px * var(--scale));
      .view-home-header-title {
        font: bold calc(34px * var(--scale))/calc(38px * var(--scale)) 'Open Sans';
        text-transform: uppercase;
      }
      .view-home-header-content {
        font: lighter calc(25px * var(--scale))/calc(28px * var(--scale)) 'Open Sans';
      }
      .price-container {
        .price-shadow {
          box-shadow: 3px 3px 5px var(--box-shadow-color);
          width: calc(270px * var(--scale));
          margin: auto;
          border-radius: calc(25px * var(--scale));
          padding: calc(30px * var(--scale));
          .mensalidade-antiga {
            font-size: calc(13px * var(--scale));
            text-align: left;
            margin: calc(5px * var(--scale));
            margin-left: calc(50px * var(--scale));
            text-decoration: line-through;
            opacity: 0.7;
            ::v-deep big {
              font-size: calc(18px * var(--scale));
            }
          }
          .price {
            justify-content: center;
          }
          .btn-assine-agora {
            margin: calc(10px * var(--scale)) auto 0 auto;
          }
        }
        .mensalidade-observacao {
          text-align: center;
          font: lighter calc(14px * var(--scale))/calc(14px * var(--scale)) 'Open Sans';
        }
      }
    }
  }
  #porque-assinar-woliflix {
    background-color: var(--primary);
    color: var(--on-primary);
    display: flex;
    flex-wrap: wrap;
    padding: calc(60px * var(--scale)) var(--margin);
    justify-content: center;
    .left-container {
      flex: 1;
      min-width: 50%;
      max-width: calc(700px * var(--scale));
      .view-home-title-porque-assinar-woliflix {
        width: 100%;
        text-align: center;
        margin: calc(20px * var(--scale)) 0 calc(40px * var(--scale)) 0;
        font: bold calc(34px * var(--scale))/calc(32px * var(--scale)) "Open Sans";
        text-transform: uppercase;
      }
      .motivos {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        justify-items: center;
        .motivo {
          text-align: center;
          max-width: calc(215px * var(--scale));
          .icon {
            margin: auto;
            height: calc(60px * var(--scale));
            width: calc(60px * var(--scale));
          }
          .description::v-deep {
            font: normal calc(18px * var(--scale))/calc(18px * var(--scale)) "Open Sans";
            b {
              text-transform: uppercase;
            }
          }
        }
      }
    }
    .right-container {
      width: calc(451px * var(--scale));
    }
    @media (max-width: 450px) {
      .left-container {
        .motivos {
          grid-template-columns: repeat(2, 1fr);
        }
      }
    }
  }
  #cursos {
    .view-home-title-conteudo {
      font: bold calc(50px * var(--scale))/calc(50px * var(--scale)) 'Open Sans';
      margin: calc(60px * var(--scale)) 0;
      text-align: center;
    }
    .btn-todos-cursos {
      margin: calc(55px * var(--scale)) auto calc(50px * var(--scale)) auto;
    }
  }
  #faq {
    margin: 0 var(--margin);
    .faq-title {
      font: bold calc(50px * var(--scale))/calc(50px * var(--scale)) 'Open Sans';
      margin: calc(100px * var(--scale)) 0 calc(50px * var(--scale)) 0;
      text-align: center;
    }
    .btn-assine-agora {
      margin: calc(90px * var(--scale)) auto calc(50px * var(--scale)) auto;
    }
  }
  #dialog-detalhe-curso {
    .video-indisponivel {
      width: 100%;
      height: 254px;
      background-color: var(--surface);
      color: var(--on-surface);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      opacity: 0.75;
      svg {
        height: 35px;
        width: 35px;
      }
    }
    .gostou-do-conteudo {
      font: 500 22px/38px 'Open Sans';
    }
  }
}
</style>
